<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>パスワード変更</span>
    </div>
    <div class="text item">
      <p class="error_message" v-if="errors.loginError">{{ errors.loginError }}</p>
      <el-form ref="form" :model="form" label-width="190px">
        <el-form-item label="現在のパスワード" :error="errors.currentPasswordError">
          <el-input v-model="form.currentPassword" show-password></el-input>
        </el-form-item>
        <el-form-item label="新しいパスワード" :error="errors.newPasswordError">
          <el-input v-model="form.newPassword" show-password></el-input>
        </el-form-item>
        <el-form-item label="新しいパスワード(確認用)" :error="errors.confirmPasswordError">
          <el-input v-model="form.confirmPassword" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">変更</el-button>
          <el-button @click="backTop">戻る</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      form: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      errors: {
        currentPasswordError: '',
        newPasswordError: '',
        confirmPasswordError: '',
        loginError: ''
      }
    }
  },
  methods: {
    onSubmit() {
      this.errors.currentPasswordError = ''
      this.errors.newPasswordError = ''
      this.errors.confirmPasswordError = ''
      this.errors.loginError = ''

      axios
        .post('/api/store/change-password', this.form)
        .then((res) => {
          // this.$router.push({name: 'top'});
          this.$notify({
            title: '変更完了',
            message: 'パスワードの変更が完了しました。',
            type: 'success'
          })

          this.form.currentPassword = ''
          this.form.newPassword = ''
          this.form.confirmPassword = ''
        })
        .catch((error) => {
          const data = error.response.data
          if (error.response.status === 422) {
            if (data.currentPassword) {
              this.errors.currentPasswordError = data.currentPassword[0]
            }
            if (data.newPassword) {
              this.errors.newPasswordError = data.newPassword[0]
            }
            if (data.confirmPassword) {
              this.errors.confirmPasswordError = data.confirmPassword[0]
            }
            if (data.login) {
              this.errors.loginError = data.login[0]
            }
          } else {
            alert('パスワードのリセットが出来ません。再度時間を置いて試してください。')
          }
        })
    },
    backTop() {
      this.transitionSame('top')
    }
  }
}
</script>

<style lang="scss" scoped>
.box-card {
  max-width: 700px;
  margin: 0 auto;
}

.error_message {
  color: red;
}
.el-form-item::v-deep .el-form-item__error {
  position: static;
}
</style>
